import { RootState } from '@store/rootReducer'

export const selectPack = (id:string) => (state: RootState) => {return state.editor.packs.packs[id]}
